import styled from 'styled-components'

export const CustomerTaskConfigDialogueWrapper = styled.div`
  width: 100%;
  padding-top: 20px;
  height: 91%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
`

export const Title = styled.div`
  width: 100%;
  font-size: 20px;
  padding-left: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`

export const SubTitle = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
  font-size: 14px;
  padding-left: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`

export const TableRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 470px;
  line-height: 45px;
`

export const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 470px;
  justify-content: flex-end;
  margin-top: 10px;
`

export const ItemColumn = styled.div`
  width: 50px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-left: 20px;
`

export const ConfigColumn = styled.div`
  width: 240px;
  padding-left: 20px;
`

export const DeleteConfig = styled.div`
  font-weight: bold;
  color: rgba(255, 0, 0, 0.7);
  font-size: 14px;
  cursor: pointer;

  &:hover {
    font-weight: bolder;
    color: rgba(255, 0, 0, 1.0);
  }
`

export const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 200px;
  width: 100%;
`

export const LoadingText = styled.div`
  font-size: 12px;
  margin-top: 20px;
`